import React, { useEffect, useState } from "react";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./AllOrders.css";

const AllOrders = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const storedUser = sessionStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
   const [dropdownOpen, setDropdownOpen] = useState({});

  useEffect(() => {
    if (user?.role === "admin") {
      const fetchAllOrders = async () => {
        setLoading(true);
        try {
          const res = await axios.get(`${API_URL}/orders`);
          setOrders(res.data);
        } catch (err) {
          console.error(
            "❌ Error fetching all orders:",
            err.response?.data || err.message
          );
          setMessage({ text: "Failed to fetch orders.", type: "error" });
        } finally {
          setLoading(false);
        }
      };

      fetchAllOrders();
    }
  }, [user?.role, API_URL]);
// Cancel Order
const cancelOrder = async (id) => {
  try {
    const token = sessionStorage.getItem("token"); // or localStorage
    await axios.put(
      `${API_URL}/orders/${id}/cancel`,
      {}, // body can be empty if not needed
      {
        headers: {
          Authorization: `Bearer ${token}`, // send JWT
        },
      }
    );

    setOrders((prev) =>
      prev.map((order) =>
        order._id === id ? { ...order, status: "Cancelled" } : order
      )
    );
    setMessage({ text: `Order ${id} cancelled successfully.`, type: "success" });
  } catch (err) {
    console.error("❌ Error cancelling order:", err.response?.data || err.message);
    setMessage({ text: "Failed to cancel order.", type: "error" });
  }
};

// Process Refund
const processRefund = async (id) => {
  try {
    const token = sessionStorage.getItem("token");
    await axios.put(
      `${API_URL}/orders/${id}/refunded`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setOrders((prev) =>
      prev.map((order) =>
        order._id === id ? { ...order, status: "Refunded" } : order
      )
    );
    setMessage({ text: `Refund processed for order ${id}.`, type: "success" });
  } catch (err) {
    console.error("❌ Error processing refund:", err.response?.data || err.message);
    setMessage({ text: "Failed to process refund.", type: "error" });
  }
};


  // ✅ Generate Invoice PDF
  const generateInvoice = (order) => {
    const invoiceElement = document.createElement("div");
    invoiceElement.className = "invoice-template";
    invoiceElement.style.cssText = `
      font-family: 'Playfair Display', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      background: #fff;
      padding: 20px;
      border-radius: 12px;
      box-shadow: 0 2px 10px rgba(193, 28, 132, 0.07);
      max-width: 800px;
      margin: 0 auto;
      color: #333;
    `;
    invoiceElement.innerHTML = `
      <div style="text-align: center; color: #C11C84;">
        <h2 style="font-weight: 700; letter-spacing: 1.2px;">Vaibhavam</h2>
        <p><strong>Invoice #:</strong> ${order.orderId || order._id}</p>
        <p><strong>Date:</strong> ${new Date(order.createdAt).toLocaleDateString()}</p>
      </div>
      <hr style="border: 1px solid #ffd1dc;" />
      <div style="display: flex; justify-content: space-between;">
        <p><strong>From:</strong><br/> Vaibhavam<br/> Tamil Nadu, India</p>
        <p><strong>To:</strong><br/> User: ${order.userName}<br/> ID: ${order.userId}</p>
      </div>
      <hr style="border: 1px solid #ffd1dc;" />
      <div>
        <p><strong>Venue:</strong> ${order.venueName}</p>
        <p><strong>Payment Type:</strong> ${order.paymentType}</p>
        <p><strong>Status:</strong> ${order.status}</p>
      </div>
      <hr style="border: 1px solid #ffd1dc;" />
      <div style="text-align: center;">
        <h3 style="color: #C11C84;">Total Paid: ₹${order.amountPaid}</h3>
      </div>
      <p style="text-align: center; color: #C11C84; font-style: italic;">
        ✨ Thank you for booking with Vaibhavam ✨
      </p>
    `;

    document.body.appendChild(invoiceElement);

    html2canvas(invoiceElement, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`invoice_${order.orderId || order._id}.pdf`);
      document.body.removeChild(invoiceElement);
    });
  };

  if (user?.role !== "admin") {
    return (
      <p style={{ color: "#C11C84", textAlign: "center", marginTop: "20px", fontFamily: "'Playfair Display', serif" }}>
        🚫 Access Denied. Only admins can view this page.
      </p>
    );
  }

  return (
    <div
      className="container mt-4"
      style={{
        maxWidth: "900px",
        margin: "60px auto",
        padding: "36px 28px",
        background: "#fffaf0",
        borderRadius: "18px",
        boxShadow: "0 8px 32px rgba(193, 28, 132, 0.19)",
      }}
    >
      <h2
        style={{
          color: "#C11C84",
          textAlign: "center",
          fontFamily: "'Playfair Display', serif",
          letterSpacing: "1.2px",
          marginBottom: "25px",
        }}
      >
        📦 All Orders 
      </h2>

      {message.text && (
        <div
          className={`vendor-form-message ${message.type}`}
          style={{
            textAlign: "center",
            padding: "10px 13px",
            borderRadius: "8px",
            marginBottom: "15px",
            fontWeight: 500,
            fontSize: "15px",
            backgroundColor: message.type === "success" ? "#e6f4ea" : "#fdecea",
            color: message.type === "success" ? "#2f8f4e" : "#C11C84",
            border: `2px solid ${message.type === "success" ? "#ffd700" : "#C11C84"}`,
          }}
        >
          {message.text}
        </div>
      )}

      {loading && (
        <p style={{ color: "#C11C84", textAlign: "center", fontFamily: "'Playfair Display', serif" }}>
          ⏳ Loading orders...
        </p>
      )}

      {!loading && orders.length > 0 ? (
        <div
          style={{
            maxHeight: "500px",
            overflowY: "auto",
            padding: "15px",
            background: "#ffd1dc",
            borderRadius: "13px",
            boxShadow: "0 2px 10px rgba(193, 28, 132, 0.08)",
          }}
        >
          {orders.map((order) => (
            <div
              key={order._id}
              style={{
                background: "#fff",
                border: "2px solid #C11C84",
                borderRadius: "14px",
                padding: "18px",
                marginBottom: "15px",
                boxShadow: "0 2px 10px rgba(193, 28, 132, 0.07)",
                transition: "transform 0.2s, box-shadow 0.2s",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 6px 16px rgba(193, 28, 132, 0.17)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 10px rgba(193, 28, 132, 0.07)";
              }}
            >
              <h5 style={{ color: "#C11C84", fontWeight: 700, fontFamily: "'Playfair Display', serif" }}>
                {order.venueName}
              </h5>
              <p style={{ margin: "5px 0" }}>
                <strong>Invoice #:</strong> {order.orderId || order._id}
              </p>
              <p style={{ margin: "5px 0" }}>
                <strong>Amount Paid:</strong> ₹{order.amountPaid}
              </p>
              <p style={{ margin: "5px 0" }}>
                <strong>Payment Type:</strong> {order.paymentType}
              </p>
              <p style={{ margin: "5px 0" }}>
                <strong>Status:</strong> {order.status}
              </p>
              <p style={{ margin: "5px 0" }}>
                <strong>Date:</strong> {new Date(order.createdAt).toLocaleString()}
              </p>
              <p style={{ margin: "5px 0" }}>
                <strong>User:</strong> {order.userName}
                <br />
                <small style={{ color: "#C11C84" }}>ID: {order.userId}</small>
              </p>

              
              {/* Dropdown Actions */}
               <div style={{ position: "relative", marginTop: "10px" }}>
                <button
                  onClick={() => setDropdownOpen({ ...dropdownOpen, [order._id]: !dropdownOpen[order._id] })} // ✅ CHANGE: Correctly toggle dropdown per order
                  style={{ padding: "6px 13px", background: "linear-gradient(135deg, #C11C84 80%, #ffd700 120%)", color: "#fff", border: "none", borderRadius: "7px", fontWeight: 700, cursor: "pointer" }}
                >
                  ⚙️ Actions ▾
                </button>

                {dropdownOpen[order._id] && (
                  <div style={{ position: "absolute", top: "40px", left: 0, background: "#fff", borderRadius: "7px", boxShadow: "0 4px 10px rgba(0,0,0,0.15)", zIndex: 100, minWidth: "150px", overflow: "hidden" }}>
                    <div onClick={() => { generateInvoice(order); setDropdownOpen({ ...dropdownOpen, [order.orderId]: false }); }} style={{ padding: "10px", cursor: "pointer" }}>🧾 Invoice</div>
                    <div onClick={() => { if (order.status !== "Cancelled" && order.status !== "Refunded") cancelOrder(order.orderId); setDropdownOpen({ ...dropdownOpen, [order._id]: false }); }} style={{ padding: "10px", cursor: order.status === "Cancelled" || order.status === "Refunded" ? "not-allowed" : "pointer", color: order.status === "Cancelled" || order.status === "Refunded" ? "#ccc" : "#C11C84" }}>🚫 Cancel</div>
                    <div onClick={() => { if (order.status === "confirmed" && order.paymentType !== "Pending") processRefund(order.orderId); setDropdownOpen({ ...dropdownOpen, [order._id]: false }); }} style={{ padding: "10px", cursor: order.status !== "confirmed" || order.paymentType === "Pending" ? "not-allowed" : "pointer", color: order.status !== "confirmed" || order.paymentType === "Pending" ? "#ccc" : "#C11C84" }}>💰 Refund</div>
                  </div>
                )}
              </div>
              <div style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
                <button
                  onClick={() => generateInvoice(order)}
                  style={{
                    padding: "6px 13px",
                    background: "linear-gradient(135deg, #C11C84 80%, #ffd700 120%)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "7px",
                    fontSize: "13px",
                    fontWeight: 700,
                    cursor: "pointer",
                    boxShadow: "0 3px 7px rgba(193, 28, 132, 0.39)",
                    transition: "all 0.3s ease",
                    fontFamily: "'Playfair Display', serif",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.background = "linear-gradient(135deg, #ffd700, #C11C84)") &&
                    (e.target.style.color = "#C11C84")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.background = "linear-gradient(135deg, #C11C84 80%, #ffd700 120%)") &&
                    (e.target.style.color = "#fff")
                  }
                >
                  🧾 Invoice
                </button>
                <button
                  onClick={() => cancelOrder(order.orderId)}
                  disabled={order.status === "Cancelled" || order.status === "Refunded"}
                  style={{
                    padding: "6px 13px",
                    background: order.status === "Cancelled" || order.status === "Refunded"
                      ? "#ccc"
                      : "#C71585",
                    color: "#fffaf0",
                    border: "none",
                    borderRadius: "7px",
                    fontSize: "13px",
                    fontWeight: 700,
                    cursor: order.status === "Cancelled" || order.status === "Refunded"
                      ? "not-allowed"
                      : "pointer",
                    boxShadow: "0 3px 7px rgba(193, 28, 132, 0.39)",
                    transition: "all 0.3s ease",
                    fontFamily: "'Playfair Display', serif",
                  }}
                  onMouseOver={(e) =>
                    order.status !== "Cancelled" &&
                    order.status !== "Refunded" &&
                    (e.target.style.background = "#ffd700") &&
                    (e.target.style.color = "#C11C84")
                  }
                  onMouseOut={(e) =>
                    order.status !== "Cancelled" &&
                    order.status !== "Refunded" &&
                    (e.target.style.background = "#C71585") &&
                    (e.target.style.color = "#fffaf0")
                  }
                >
                  🚫 Cancel
                </button>
                <button
                  onClick={() => processRefund(order.orderId)}
                  disabled={order.status !== "confirmed" || order.paymentType === "Pending"}
                  style={{
                    padding: "6px 13px",
                    background: order.status !== "confirmed" || order.paymentType === "Pending"
                      ? "#ccc"
                      : "#C71585",
                    color: "#fffaf0",
                    border: "none",
                    borderRadius: "7px",
                    fontSize: "13px",
                    fontWeight: 700,
                    cursor: order.status !== "confirmed" || order.paymentType === "Pending"
                      ? "not-allowed"
                      : "pointer",
                    boxShadow: "0 3px 7px rgba(193, 28, 132, 0.39)",
                    transition: "all 0.3s ease",
                    fontFamily: "'Playfair Display', serif",
                  }}
                  onMouseOver={(e) =>
                    order.status === "confirmed" &&
                    order.paymentType !== "Pending" &&
                    (e.target.style.background = "#ffd700") &&
                    (e.target.style.color = "#C11C84")
                  }
                  onMouseOut={(e) =>
                    order.status === "confirmed" &&
                    order.paymentType !== "Pending" &&
                    (e.target.style.background = "#C71585") &&
                    (e.target.style.color = "#fffaf0")
                  }
                >
                  💰 Refund
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        !loading && (
          <p style={{ color: "#C11C84", textAlign: "center", fontFamily: "'Playfair Display', serif" }}>
            No orders found.
          </p>
        )
      )}
    </div>
  );
};

export default AllOrders;